import ForecastRuleFetch from "./ForecastRuleFetch";
import ForecastRuleGet from "./ForecastRuleGet";

export default class ForecastRule {
  enum: string;
  label: string;
  selectedLabel: string;
  fetch: ForecastRuleFetch;
  get: ForecastRuleGet;
  icon: string;

  constructor(
    enumValue: string,
    label: string,
    selectedLabel: string,
    fetch: ForecastRuleFetch,
    get: ForecastRuleGet,
    icon: string
  ) {
    this.enum = enumValue;
    this.label = label;
    this.selectedLabel = selectedLabel;
    this.fetch = fetch;
    this.get = get;
    this.icon = icon;
  }
}
